module.exports = __webpack_public_path__ + "img/farzana-christopher-119.6170dfba.jpg";